import React from "react";
import SubPageTheme from "../../components/SubPageTheme";
import { cepData } from "../../utils/data";

export default function Seo(props) {
  return <SubPageTheme {...cepData} />;
}
